/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import { FlowState } from '@staffino/model';
import CachedFlowBridge from './cached-flow-bridge';

export default class PreviewFlowBridge extends CachedFlowBridge {
  async commitState(state: FlowState): Promise<void> {
    console.debug('Executing saveState in preview, not sending data', state);
  }

  async saveState(state: FlowState): Promise<void> {
    console.debug('Executing saveState in preview, not sending data', state);
  }
}
